import PagesApi from '@/api/pages'

const actions = {
  async INITIALIZE({ commit, dispatch }, { uriPaths }) {
    const res = await dispatch('fetchUriAuth', uriPaths)
    const uriAuths = res.data.item
    commit('INITIALIZE', { uriAuths })
  },
  async fetchUriAuth(context, uriPaths) {
    const res = await PagesApi.getAuth(uriPaths)
    return res
  },
  RESET({ commit }) {
    commit('RESET')
  },
}

export default actions
